module.exports = __webpack_public_path__ + "static/media/via_cargo_home_mobile.7bf64530.jpg";